<template>
  <!-- Kontener filtrów aktywności użytkowników.
       Używa flexboxa do rozłożenia filtrów w jednym rzędzie (d-flex, justify-content-between) -->
  <div class="activity-list d-flex justify-content-between filters-container">
    <!-- Filtr tekstowy po użytkowniku (np. login, imię, nazwisko) -->
    <user-text-filter :store="filtersStore" />
    <!-- Filtr po typie zdarzenia (np. logowanie, wylogowanie, włączenie znaku, itp.) -->
    <event-types-filter :store="filtersStore" />
    <!-- Filtr zakresu dat (od-do) dla wybranych aktywności -->
    <date-range :store="filtersStore" />
  </div>
</template>

<script>
// Import store Pinia, który przechowuje stan wybranych filtrów dla aktywności użytkownika
import { useUserActivityFiltersStore } from "@/stores/userActivityFilters";
// Import komponentów filtrujących - każdy filtr to osobny komponent, można go łatwo wymienić lub rozwinąć
import EventTypesFilter from "@/components/users/EventTypesFilter";
import DateRange from "@/components/users/DateRange";
import UserTextFilter from "@/components/users/UserTextFilter";

export default {
  name: "FilterActivityList", // Nazwa komponentu

  // Rejestracja używanych komponentów
  components: {
    UserTextFilter,
    EventTypesFilter,
    DateRange,
  },

  // Composition API: setup
  setup() {
    // Pobranie instancji store Pinia dla filtrów aktywności użytkownika
    const filtersStore = useUserActivityFiltersStore();
    // Udostępnienie store w template
    return { filtersStore };
  },
};
</script>

<style scoped>
/* Styl nagłówka filtrów (jeśli używasz np. h5 w którymś z filtrów) */
.filter h5 {
  margin: 0;
  padding: 10px 20px;
  background-color: white;
  position: relative;
  background: white url("../assets/h-filter-bg.png") repeat-y right top;
}

/* Ogólne style dla wierszy filtrów (jeśli są używane w subkomponentach) */
.row {
  height: 30px;
  line-height: 25px;
}

/* Style dla sekcji z informacją (np. legenda) */
.info {
  font-size: 12px;
  padding: 12px 20px;
  border-bottom: 1px solid #bbbbbb;
}

.info p {
  font-size: 12px;
  margin: 0;
}

/* Ikonka zwijania/rozwijania legendy/sekcji filtrów */
.icon-collapse {
  background: url("../assets/icons/zwin.png") no-repeat left top;
  width: 19px;
  height: 19px;
  position: absolute;
  cursor: pointer;
  right: 20px;
}
.collapsed.icon-collapse {
  background: url("../assets/icons/rozwin.png") no-repeat left top;
}
</style>
